import { RECOVER_PASSWORD_PATH } from 'user/routes';
import FormWithValidation from 'shared/form/components/FormWithValidation';
import { LOGIN_ERROR_MESSAGES } from 'auth/constants/LoginErrorMessages';
import { Button } from '@orbita-ui/core';
import {
  ForgotPasswordLink,
  LoginFormTitle,
  StyledLoginFormWithValidation,
} from './LoginForm.styles';
import { useNavigate } from 'react-router-dom';

export function LoginForm({ onSubmit, disableSignIn }) {
  const navigate = useNavigate();

  const goToForgetPassword = () => {
    navigate(RECOVER_PASSWORD_PATH);
  };

  return (
    <StyledLoginFormWithValidation onSubmit={onSubmit}>
      <LoginFormTitle>Ingreso</LoginFormTitle>
      <FormWithValidation.TextInput
        name="username"
        placeholder="Usuario"
        fullWidth
        registerOptions={{
          required: LOGIN_ERROR_MESSAGES.usernameRequired,
        }}
      />
      <FormWithValidation.PasswordInput
        fullWidth
        name="password"
        registerOptions={{
          required: LOGIN_ERROR_MESSAGES.passwordRequired,
        }}
      />
      <Button type="submit" size="fullWidth" disabled={disableSignIn}>
        Ingresar
      </Button>
      <div>
        <ForgotPasswordLink onClick={() => goToForgetPassword()}>
          ¿Olvidó su clave?
        </ForgotPasswordLink>
      </div>
      <div>
        <ForgotPasswordLink>
          <a href="https://prismanet.prismamediosdepago.com/flota/main">
            Recarga de tarjetas
          </a>
        </ForgotPasswordLink>
      </div>
    </StyledLoginFormWithValidation>
  );
}
